import styled from "styled-components";

import Image from '../../../../assets/images/business/b_m_cnt12_img1.png'

export const Container = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  height: 600px;
  background-image: url(${Image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media only screen and (${({theme}) => theme.media.large}) {
    height: 600px;
    margin-top: 200px;
    margin-bottom: 50px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    height: 900px;
  }
`

export const TextBlock1 = styled.div`
  position: relative;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  top: 100px;
  
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    position: absolute;
    width: 600px;
    top: 50px;
    left: 120px;
    font-weight: 600;
    text-align: left;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    top: 100px;
    left: 220px;
  }
`

export const TextBlock2 = styled.div`
  position: relative;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  top: 150px;

  font-size: 16px;
  font-weight: 500;
  line-height: 30px;

  @media only screen and (${({theme}) => theme.media.large}) {
    position: absolute;
    width: 600px;
    top: 200px;
    right: 200px;

    font-size: 22px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: 0;
    text-align: right;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    top: 400px;
  }
`